import styled from "styled-components";



export const Wrapper = styled.div`
  .filter{
    margin-bottom: 5px;
    display: flex;
    justify-content: right;
}
.pointer{
    cursor: pointer;
}
.add-expense{
    margin-bottom: 10px;
}


`;